// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__xPZqo","change-color-on-hover":"BookNowBtn_change-color-on-hover__pmfzz","button":"BookNowBtn_button__cN-pO"};